import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ProjectIntegrationState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allProjects: [] | null | any;
}

const initialState: ProjectIntegrationState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allProjects: null,
};

export const projectIntegrationSlice = createSlice({
    name: 'ProjectIntegration',
    initialState,
    reducers: {
        setProjectIntegration: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setAllProjects: (state, action) => {
            state.allProjects = action.payload.data;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setProjectIntegration, setAllProjects, reset } = projectIntegrationSlice.actions;
export const getAllProjectDetails = (state: RootState) => state.projectIntegration.data;
export const getProjectTotalRecords = (state: RootState) => state.projectIntegration.totalRecords;
export const getAllProjectsList = (state: RootState) => state.projectIntegration.allProjects;
export default projectIntegrationSlice.reducer;
